import React from 'react';

import TextField from '@mui/material/TextField';

//const InputComponent: any = ({ inputRef, ...other }) => <div {...other} />;
const InputComponent: any = React.forwardRef((props, ref: any) => <div {...props} ref={ref} />);

interface OultinedDivProps {
  labelProps: any;
  variant: any;
  children: React.ReactNode;
  testId?: string;
}

const OutlinedDiv: React.FC<OultinedDivProps> = ({
  children,
  testId = 'multicheck',
  labelProps,
  variant,
}) => {
  return (
    <TextField
      {...labelProps}
      variant={variant}
      multiline
      data-testid={testId}
      InputProps={{
        inputComponent: InputComponent,
      }}
      inputProps={{ children: children }}
    />
  );
};
export default OutlinedDiv;
